import script from "./CaskAdminShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskAdminShow.vue?vue&type=script&setup=true&lang=js"

import "./CaskAdminShow.vue?vue&type=style&index=0&id=68791a60&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68791a60"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QSeparator});
